// import mixins from './mixins';

// const theme = {
//   bp: {
//     mobileS: `max-width: 330px`,
//     mobileM: `max-width: 400px`,
//     mobileL: `max-width: 480px`,
//     tabletS: `max-width: 600px`,
//     tabletL: `max-width: 768px`,
//     desktopXS: `max-width: 900px`,
//     desktopS: `max-width: 1080px`,
//     desktopM: `max-width: 1200px`,
//     desktopL: `max-width: 1400px`,
//   },

//   mixins,
// };

// export default theme;

import mixins from './mixins';

const theme = {
  // Breakpoints remain the same to ensure the site stays responsive
  bp: {
    mobileS: `max-width: 330px`,
    mobileM: `max-width: 400px`,
    mobileL: `max-width: 480px`,
    tabletS: `max-width: 600px`,
    tabletL: `max-width: 768px`,
    desktopXS: `max-width: 900px`,
    desktopS: `max-width: 1080px`,
    desktopM: `max-width: 1200px`,
    desktopL: `max-width: 1400px`,
  },

  // These are the core colors of your "Deep Infrastructure" palette 
  // for easy reference in Styled Components props
  colors: {
    background: '#0f172a',
    primaryText: '#f1f5f9',
    accent: '#38bdf8',
    secondaryText: '#94a3b8',
  },

  mixins,
};

export default theme;